import React, { Component } from 'react';

import { Container, Row, Col , Modal, Button} from 'react-bootstrap';

import * as fn from '../library/function';
import * as constants from '../config/constants/AppConstants';
import * as helper from '../library/helper';
import * as util from '../library/utilitys';

import CommonPageHeader from './components/CommonPageHeader';
import CommonToolbar from './components/CommonToolbar';
import CommonToast from './components/CommonToast';
import CommonConfirmModal from './components/CommonConfirmModal';
import CommonPreviewFileModal from './components/CommonPreviewFileModal';

import CommonTokenExpired from './components/CommonTokenExpired';

import Cookies from "js-cookie";

/** withRouter */
import withRouter from "./components/withRouter"

/** start individual component */
import InputTypeAImport100Grad from './inputs/InputTypeAImport100Grad';
import SearchTypeAImport100Grad from './searchs/SearchTypeAImport100Grad';
import DataTableTypeAImport100Grad from './dataTables/DataTableTypeAImport100Grad';
/** end individual component */

import * as Actions from './actions/ActionCenter';

import { GlobalStates } from './states/GlobalStates';

/** individual page state */
import { PageDataState } from './states/TypeADataImport100GradState';

/** requester handle */
import requester from "../library/Requester"; 

/** define end point */
const TABLE = `type_a_import_100_grad`;
const URL = `api/master/${TABLE}`;

const rawProfile = Cookies.get("userProfile");
const userProfile = rawProfile ? JSON.parse(rawProfile) : {};

class TypeAImport100Grad extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);
    }

    initialize = async () => {
        await this.loadMasterbase();
        await this.loadDataTable();
    }

    loadMasterbase = async () => {
        let sets = [
            {key: "academy", filter: [{field: "status", value: "0"}]},
        ]; 
        await Actions.loadMasterbase(this.updateState, sets);
    }

    loadDataTable = async (search=false) => { 
        const { Searchs, DataTable } = this.state;
        await Actions.loadDataTable( 
            this.updateState, 
            `${URL}/pagination`, 
            fn.getInputSearch({...Searchs, page: { id: 'page', value: search ? 1 : DataTable.pagination.currentPage }})
        );
    }
    
    navigate = (obj = {}) => {
        // const { Searchs, DataTable, Operation } = this.state; 
        
        // const key = 'type_a';

        // Actions.navigate(this.props.navigate, "/apps/type-a-benefits-received", {
        //     direction: 'drilldown',
        //     key: key,
        //     restore: {},
        //     [key]: {
        //         parameters: {...obj},
        //         searchs: Searchs,
        //         operation: Operation,
        //         currentPage: DataTable.pagination.currentPage,
        //     },
        // });
    };

    updateSomething = async (obj, element, pk) => {
        console.log(">>>>", obj, element, pk);
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'OffCanvas', mode: 'update', bool: true},
            this.state.Inputs
        );
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
    }

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state;

        // ดึงไฟล์จริงจาก input แบบตรงๆ
        const realFile = document.getElementById("import_data").files[0];

        console.log("realFile =", realFile);

        const formData = new FormData();
        formData.append("file", realFile);
        formData.append("academy_id", Inputs.academy_id.value);

        await requester.post(
            "/api/graduates/one-hundred-percent/upload",
            formData,
            {
                headers: { 
                    "X-CSRF-Token": this.state.csrfToken,
                    "Content-Type": "multipart/form-data"
                }
            }
        )
        .then( async (response) => {
                console.log("response", (!response?.data?.errors || response.data.errors.length === 0));
            if(response?.data?.success === true && (!response?.data?.errors || response.data.errors.length === 0) ){
                await Actions.submitData(
                    this.updateState,
                    `${URL}`,
                    Action.Mode, 
                    fn.getInputForm({...Inputs}),
                    this.loadDataTable
                );
            }else if(response?.data?.success === false){
                this.setState({ error: response?.data?.errors?.join('\n\n'), showModal: true }, () => {
                    util.debug(this.state, 'GET-TOKEN-AND-USER-PROCESS-FAIL');
                });  
            }else{
                this.setState({ error: response?.data?.errors?.join('\n\n'), showModal: true }, () => {
                    util.debug(this.state, 'GET-TOKEN-AND-USER-PROCESS-FAIL');
                });            
            }
        })
        .catch((error) => {
            console.log("error", error?.response?.data?.error);
            
                
        });
    };

    componentDidMount = async () => {
        await this.initialize(); 
    }

    componentDidUpdate = async () => {}    

    render = () => {

        let { Action, Searchs, DataTable, Inputs, InputGroup, Masterbase, Deletes, Operation, Token} = this.state;

        let AppProps = constants.AppProps[helper.getCurrentRoute()];

        return (
            <>
                <Container>

                    <CommonPageHeader object={AppProps}/>

                    <CommonTokenExpired Token={Token} />

                    <CommonPreviewFileModal
                        Action={Action}
                        onClose={() => Actions.handleClosePreviewFile(this.updateState)}
                    />
                    
                    <CommonToolbar 
                        config={AppProps.toolbar}
                        
                        Operation={Operation}
                        Deletes={Deletes}

                        onToggleSearch={(e) => Actions.handleToggleItem(this.updateState, 'Operation', 'Search')}

                        onRefreshDataTable={async (e) => await this.loadDataTable()}
                        
                        onCreateItem={(e) => Actions.handleOpenInputForm(this.updateState, 'OffCanvas', 'new', true)}
                        onModalAction={(e) => Actions.handleControlModal(this.updateState, e)}
                    />

                    <CommonToast 
                        toast={Action.Toast} 

                        onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                    />

                    <CommonConfirmModal 
                        Action={Action}
                        Deletes={Deletes}

                        onCallback={async (e) => { 
                            let result = await Actions.handleControlModal(this.updateState, e);
                            if(result.action){
                                if (result.section === 'Delete'){ await this.deleteData(); }
                            }
                         }}
                    />

                    <SearchTypeAImport100Grad 
                        Action={Action}
                        Searchs={Searchs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}

                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}

                        onSearch={async (e) => await this.loadDataTable(true)}
                    />

                    <DataTableTypeAImport100Grad 
                        Action={Action}
                        DataTable={DataTable}
                        Inputs={Inputs}
                        Deletes={Deletes}
                        Masterbase={Masterbase}
                        UserCookie={userProfile}

                        onSetEdit={async (e, obj) => { await this.fetchForEdit(obj); }}
                        // onNavigate={(e, obj) => this.navigate(obj)}
                        onPreviewFile={(e) => Actions.handlePreviewFile(this.updateState, e)}
                        onDropDownChange={async(e, element, pk) => { await this.updateSomething(e, element, pk)} }

                        onCheckDelete={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)}
                        onCheckDeleteAll={(e, deletes) => Actions.handleDataTableToggleDeleteAll(this.updateState, e, deletes)}
                        onPaginationChange={(paging) => Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)}
                    />

                    <InputTypeAImport100Grad 
                        URL={URL}
                        
                        App={AppProps}

                        Action={Action}
                        Inputs={Inputs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}
                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                        
                        onPreviewFile={(e) => Actions.handlePreviewFile(this.updateState, e)}
                        onDeleteFile={(field, pk) => Actions.deleteFile(this.updateState, URL, field, pk)}

                        onCloseAlert={(e) => { Actions.handleCloseAlert(this.updateState, 'Alert', e); }}
                        onSubmit={async (e) => { await this.submitData()}}
                        
                        onSetEdit={async (e, obj) => { await this.fetchForEdit(obj); }}
                        
                        onDiscardSubmit={(e) => { Actions.handleDiscardInputs(this.updateState, 'Inputs'); }}
                        onClose={(e) => {
                                Actions.handleDiscardInputs(this.updateState, 'Inputs');
                                Actions.handleCloseInputForm(this.updateState, 'OffCanvas')
                            }
                        }
                    />

                </Container>
                <Modal
                    show={this.state.showModal}
                    onHide={() => this.setState({ showModal: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>ไม่สามารถนำเข้าข้อมูลได้</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ whiteSpace: 'pre-line' }}>
                            {this.state.error}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showModal: false })}>
                            ปิดหน้าต่าง
                        </Button>
                    </Modal.Footer>
                </Modal> 
            </>
        )
    }
}

export default withRouter(TypeAImport100Grad);